export const OUT_OF_STOCK_LABEL = "Out of Stock";



export const isPurchasable = (product) =>

  product?.listing_status === "active" &&

  product?.is_active !== false &&

  Number(product?.stock_count ?? 0) > 0;



export const isOutOfStock = (product) =>

  product?.listing_status !== "delisted" &&

  product?.is_active !== false &&

  !isPurchasable(product);



export const listingLabel = (product) => {

  if (product?.listing_status === "delisted") return "Delisted";

  if (product?.listing_status === "sold" || Number(product?.stock_count ?? 0) <= 0) return OUT_OF_STOCK_LABEL;

  if (Number(product?.stock_count ?? 0) <= 2) return "Low stock";

  return "In stock";

};



export const listingClass = (product) => {

  const label = listingLabel(product);

  if (label === OUT_OF_STOCK_LABEL) return "text-destructive";

  if (label === "Delisted") return "text-secondary";

  if (label === "Low stock") return "text-amber-700";

  return "text-green-700";

};

